import React, { useState } from 'react';

import { Box, Grid, MenuItem, MenuList, Typography } from '@mui/material';

import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';

import { PartnerType } from '../../steps/summaryPages/step1_PartnerType';
import PartnerInformation from '../../steps/summaryPages/step2_PartnerInformation';
import { PaymentInformation } from '../../steps/summaryPages/step3_PaymentInformation';
import { PricingInformation } from '../../steps/summaryPages/step4_PricingInformation';
import { ContractInformation } from '../../steps/summaryPages/step5_ContractInformation';

interface Step {
    step: string;
    label: string;
}

interface SubNavigationProps {
    steps: Step[];
    setLastStep: (step: string) => void;
}

const SubNavigation: React.FC<SubNavigationProps> = ({ steps, setLastStep }) => {
    const [activeStep, setActiveStep] = useState<string>(steps[0].step);

    const { application } = useAddPartnerContext();

    // Handle click on a step
    const handleStepClick = (step: string) => {
        setActiveStep(step);
    };
    // Render a menu item for each step
    const renderStepNavItem = (step: string, label: string) => {
        const isActive = activeStep === step;

        return (
            <MenuItem
                key={step}
                selected={isActive}
                onClick={() => {
                    return handleStepClick(step);
                }}
                data-testid={`step-${step}-nav-item`}
                sx={{
                    display: 'flex',
                    width: '100%',
                    padding: '0',
                    overflow: 'hidden',
                }}
            >
                <Typography
                    fontSize={isActive ? '16px' : '14px'}
                    sx={{
                        color: isActive ? 'white' : '#686867',
                        fontWeight: isActive ? 500 : 400,
                        bgcolor: isActive ? '#F18F34' : 'transparent',
                    }}
                    padding="24px"
                    width="100%"
                    textAlign="center"
                >
                    {label}
                </Typography>
            </MenuItem>
        );
    };

    // Render the content based on the active step
    const renderContent = (step: string) => {
        switch (step) {
            case 'partnerType':
                return <PartnerType formSummaryData={application} />;
            case 'partnerInformation':
                return <PartnerInformation formSummaryData={application} />;
            case 'paymentInformation':
                return <PaymentInformation formSummaryData={application} />;
            case 'pricingInformation':
                return <PricingInformation formSummaryData={application} />;
            case 'contractInformation':
                return (
                    <ContractInformation setLastStep={setLastStep} formSummaryData={application} />
                );
        }
    };

    return (
        <Grid item xs={12}>
            <MenuList
                className="sub-navigation"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    border: '1px solid #F18F34',
                    borderRadius: '16px',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                    padding: '0',
                    listStyle: 'none',
                    overflow: 'hidden',
                }}
            >
                {steps.map(({ step, label }) => {
                    return renderStepNavItem(step, label);
                })}
            </MenuList>
            <Box>{renderContent(activeStep)}</Box>
        </Grid>
    );
};

export default SubNavigation;
